class AnnouncementBarCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateItemsClass();
    this.showFirstItem();
    this.handleShowHide();
  }

  updateItemsClass() {
    const items = this.querySelectorAll('.announcement-bar__item');
    items.forEach(item => {
      const blockEl = item.closest('.shopify-block');
      blockEl.setAttribute('data-device', item.getAttribute('data-device'));

      if (item.getAttribute('data-device') === 'desktop') {
        blockEl.classList.add('hidden-mobile');
      } else {
        blockEl.classList.add('hidden-desktop');
      }
    });
  }

  showFirstItem() {
    const desktopItems = this.querySelectorAll('.shopify-block[data-device="desktop"]') || [];
    const mobileItems = this.querySelectorAll('.shopify-block[data-device="mobile"]') || [];

    if (desktopItems.length > 0) {
      desktopItems[0].style.opacity = '1';
      desktopItems[0].style.visibility = 'visible';
    }

    if (mobileItems.length > 0) {
      mobileItems[0].style.opacity = '1';
      mobileItems[0].style.visibility = 'visible';
    }
  }

  handleShowHide() {
    const desktopItems = this.querySelectorAll('.shopify-block[data-device="desktop"]') || [];
    const mobileItems = this.querySelectorAll('.shopify-block[data-device="mobile"]') || [];
    const carousel = this.querySelector('#announcement-bar');
    const buttons = Array.from(this.childNodes).filter(node => node.nodeName === 'BUTTON');

    if (desktopItems.length === 0) {
      carousel.classList.add('hidden-desktop');
    }
    if (mobileItems.length === 0) {
      carousel.classList.add('hidden-mobile');
    }

    if (desktopItems.length <= 1) {
      buttons.forEach(button => {
        button.classList.add('hidden-desktop');
      });
    }

    if (mobileItems.length <= 1) {
      buttons.forEach(button => {
        button.classList.add('hidden-mobile');
      });
    }
  }
}

if (!window.customElements.get("announcement-bar-carousel")) {
  window.customElements.define("announcement-bar-carousel", AnnouncementBarCarousel);
}